import { render, staticRenderFns } from "./studies.vue?vue&type=template&id=4bdef120&scoped=true&"
import script from "./studies.vue?vue&type=script&lang=js&"
export * from "./studies.vue?vue&type=script&lang=js&"
import style0 from "./studies.vue?vue&type=style&index=0&id=4bdef120&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdef120",
  null
  
)

component.options.__file = "studies.vue"
export default component.exports